import { productEmbedType } from './analyticsWebTypes';
import type { ProductEmbeddedContext, ThirdPartyProductEmbedContext } from './types';

// eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
export const isThirdParty = (
	input: ProductEmbeddedContext,
): input is ThirdPartyProductEmbedContext => {
	return (
		input.embeddedType === productEmbedType.THIRD_PARTY &&
		input.embeddedFromTopLevelDomain !== undefined
	);
};
